import { reset } from 'redux-form';

export default function resetForm(name) {
  return (dispatch) => dispatch(reset(name));
}
